import { Mail, ArrowRight } from "lucide-react";
import { APP_SIGN_IN_URL } from "@/lib/appLinks";
import LegalPage from "@/components/marketing/LegalPage";

export default function Contact() {
  return (
    <LegalPage title="Contact" testid="contact-page">
      <p className="max-w-xl text-base leading-relaxed text-guinep-mute sm:text-lg">
        Questions about Guinep Seed, your account, or your page? We'd be glad to hear from you.
      </p>

      <a
        href="mailto:hello@guinepseed.com"
        data-testid="contact-email-button"
        className="group mt-8 flex items-center justify-between gap-4 rounded-2xl border border-guinep-line bg-guinep-soft px-6 py-6 transition-all duration-300 hover:-translate-y-0.5 hover:border-guinep-mid/40 hover:shadow-[0_20px_44px_-20px_rgba(31,58,43,0.35)]"
      >
        <span className="flex items-center gap-4">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-guinep-deep text-guinep-soft">
            <Mail size={18} strokeWidth={2.1} />
          </span>
          <span>
            <span className="block text-sm font-semibold text-guinep-ink sm:text-base">
              Email us
            </span>
            <span className="block text-sm text-guinep-mute">hello@guinepseed.com</span>
          </span>
        </span>
        <ArrowRight
          size={18}
          className="shrink-0 text-guinep-mid transition-transform duration-300 group-hover:translate-x-1"
        />
      </a>

      <p className="mt-6 text-sm leading-relaxed text-guinep-mute">
        We aim to reply within one to two business days.
      </p>

      <div className="mt-10 border-t border-guinep-line/70 pt-8">
        <p className="text-sm text-guinep-mute">
          Already have a Guinep Seed page?{" "}
          <a
            href={APP_SIGN_IN_URL}
            data-testid="contact-signin-link"
            className="font-medium text-guinep-mid underline underline-offset-4 transition-colors hover:text-guinep-deep"
          >
            Sign in
          </a>{" "}
          to manage your account.
        </p>
      </div>
    </LegalPage>
  );
}
